class ProductModuleImages extends HTMLElement {
  connectedCallback() {
    this.#toggleInput = this.querySelector('.switch');

    if (this.#toggleInput) {
      this.#toggleInput.addEventListener('change', this.#onToggleChange.bind(this));
      this.#updateToggleLabels();
    }
  }

  #toggleInput;

  #onToggleChange() {
    const isClosed = this.#toggleInput.checked;
    const closedImages = this.querySelectorAll('[data-image-role="closed"]');
    const openImages = this.querySelectorAll('[data-image-role="open"]');

    closedImages.forEach((image) => {
      image.toggleAttribute('hidden', !isClosed);
    });

    openImages.forEach((image) => {
      image.toggleAttribute('hidden', isClosed);
    });

    this.#updateToggleLabels();
  }

  #updateToggleLabels() {
    if (!this.#toggleInput) return;

    const isClosed = this.#toggleInput.checked;
    const closedLabel = this.querySelector('[data-state-label="closed"]');
    const openLabel = this.querySelector('[data-state-label="open"]');

    if (closedLabel) {
      closedLabel.dataset.active = isClosed ? 'true' : 'false';
    }

    if (openLabel) {
      openLabel.dataset.active = isClosed ? 'false' : 'true';
    }
  }
}

if (!window.customElements.get('product-module-images')) {
  window.customElements.define('product-module-images', ProductModuleImages);
}

// Les cartes n'ont pas les mêmes lignes (sélecteur de couleurs optionnel, titre sur 1 à 3
// lignes selon la langue, prix remisé ou non), ce qui décale le prix et la ligne compatibilité
// d'une carte à l'autre en desktop. Ni le subgrid (liste en flex, product-card trop profonde
// pour y propager une grille) ni une hauteur réservée en dur (les titres traduits la débordent)
// ne tiennent : on égalise à la mesure.
const PAIRS_ROW_SELECTORS = ['.product-card__info-header', '.product-card__info-price'];

class PairsWell extends HTMLElement {
  connectedCallback() {
    this.#desktop = window.matchMedia(window.themeVariables.mediaQueries.md);
    window.addEventListener('resize', this.#schedule);

    this.#schedule();
    // Les polices custom changent les métriques du titre une fois chargées.
    document.fonts.ready.then(this.#schedule);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.#schedule);
  }

  #desktop;

  #scheduled = false;

  #schedule = () => {
    if (this.#scheduled) return;
    this.#scheduled = true;

    requestAnimationFrame(() => {
      this.#scheduled = false;
      this.#equalizeRows();
    });
  };

  #equalizeRows() {
    const items = [...this.querySelectorAll('.product-card')];
    if (items.length < 2) return;

    PAIRS_ROW_SELECTORS.forEach((selector) => {
      const cells = items.map((item) => item.querySelector(selector)).filter(Boolean);
      cells.forEach((cell) => cell.style.removeProperty('min-block-size'));
      if (!this.#desktop.matches || cells.length < 2) return;

      const tallest = Math.max(...cells.map((cell) => cell.getBoundingClientRect().height));
      cells.forEach((cell) => cell.style.setProperty('min-block-size', `${tallest}px`));
    });
  }
}

if (!window.customElements.get('pairs-well')) {
  window.customElements.define('pairs-well', PairsWell);
}
